export default {"src":"/_next/static/media/selection-mod.e28687c9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};